import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export default function QueuesPage() {
  const { data = [] } = useQuery({ queryKey: ['queues'], queryFn: async () => (await api.get('/queues')).data });
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-1">Queues</h1>
      <p className="text-sm text-slate-500 mb-6">Group agents and route tickets via rules.</p>
      <div className="card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr><th className="text-left px-4 py-3">Name</th><th className="text-left px-4 py-3">Members</th><th className="text-left px-4 py-3">Open tickets</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {(data as { id: string; name: string; members: { agent: { name: string } }[]; _count: { tickets: number } }[]).map((q) => (
              <tr key={q.id}>
                <td className="px-4 py-3 font-medium">{q.name}</td>
                <td className="px-4 py-3 text-slate-600">{q.members.map((m) => m.agent.name).join(', ') || '—'}</td>
                <td className="px-4 py-3">{q._count.tickets}</td>
              </tr>
            ))}
            {(data as unknown[]).length === 0 && <tr><td colSpan={3} className="px-4 py-8 text-center text-slate-500">No queues yet — create one via API or seed.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
